import React from 'react';
import { useSelector } from 'react-redux';
import { trimDisplayNameLastWord } from '../../../util/text';
import { useReactivateListing } from '../../../hooks/useReactivateListing';
import config from '../../../config';
import css from '../ActivityFeed.css';

const { userTypeHorseowner } = config;

export default ({
    currentUser,
    currentListing: currentListingProp,
    otherParty,
    currentTransaction,
}) => {
    /** Get listing data from own entities in case the listing has been closed */
    const ownListings = useSelector(s => s['ManageListingsPage']?.ownEntities?.ownListing);

    const { listingSubstitutionId } = currentTransaction.attributes.protectedData;
    const currentListing =
        currentListingProp && currentListingProp.id
            ? currentListingProp
            : (ownListings || {})[listingSubstitutionId];
    const reactivateListing = useReactivateListing(currentListing);

    const { firstName: currentUserName } = currentUser.attributes.profile;

    const { attributes } = currentListing || { attributes: { deleted: true, state: '' } };

    const listingIsDeleted = attributes.deleted;
    const listingIsClosed = attributes.state === 'closed';
    const listingIsNotAvailable = Boolean(!currentListing?.id);
    const listingId = currentListing?.id?.uuid;

    const {
        displayName: otherPartyName,
        publicData: { userType: otherPartyType },
    } = otherParty.attributes.profile;

    const otherPartyIsOwner = otherPartyType === userTypeHorseowner;
    const listingOwnerName = otherPartyIsOwner
        ? trimDisplayNameLastWord(otherPartyName)
        : currentUserName;

    const getNotification = () => {
        if (otherPartyIsOwner && (listingIsClosed || listingIsDeleted || listingIsNotAvailable))
            return <span>{listingOwnerName} hat das Profil pausiert oder gelöscht.</span>;

        if (!otherPartyIsOwner && listingIsClosed)
            return (
                <>
                    <span>Das Profil wurde pausiert.</span>
                    <br />
                    {listingId && (
                        <span className={css.link} onClick={reactivateListing}>
                            Reaktivieren
                        </span>
                    )}
                </>
            );
        if (!otherPartyIsOwner && listingIsDeleted) return <span>Das Profil wurde gelöscht.</span>;
        return null;
    };

    const notification = getNotification();

    return notification ? <li className={css.transitionItem}>{notification}</li> : null;
};
